var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnnotation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 4.75v-3h13.25V15h-3v3.25H8.116l-.183-.183-6-6-.183-.183V4.75h.625zM6.25 6H3v5h6v6h5V6zm9 7.75v-9h-9V3H17v10.75zm-11.366-1.5 3.866 3.866V12.25z",
  clipRule: "evenodd"
})));
export default SvgAnnotation;